/* eslint-disable */
import stripIndent from '../../Vendor/strip-indent';

/**
 * Thrown when the tokens are invalid
 * @export
 * @class AuthOktaInvalidTokensError
 * @extends {Error}
 */
export class AuthOktaInvalidTokensError extends Error {
  /**
   * Creates an instance of AuthOktaInvalidTokensError
   * @param {string} message The Error `message`
   * @memberof AuthOktaInvalidTokensError
   */
  constructor(message) {
    super(message);
    this.name = `AuthOktaInvalidTokensError`;
  }
}

/**
 * Called when the tokens are invalid
 * @param {Array<any>} tokens The invalid `tokens`
 * @returns {never} never
 */
const throwOktaInvalidTokensError = (tokens) => {
  throw new AuthOktaInvalidTokensError(
    stripIndent(`
    Expected to receive an "access_token" and an "id_token".
    Got: "${tokens}"
    `),
  );
};

export default throwOktaInvalidTokensError;
